import React from 'react';
import { FormattedMessage } from 'react-intl';

const SolicitudesCards = ({ conteos, onFilter }) => {
	const cantidad = (estado) => (conteos && conteos[estado] ? conteos[estado] : 0);

	return (
		<section className="ticketWidget">
			<div className="row justify-content-around" style={{ flexWrap: 'nowrap' }}>
				<div className="col-xl-4 col-lg-4 col-12" style={{ cursor: 'pointer' }} onClick={() => onFilter('PENDIENTE')}>
					<div className="card" style={{ backgroundColor: 'rgb(222, 207, 76)' }}>
						<div className="card-content">
							<div className="card-body">
								<div className="media d-flex">
									<div className="align-self-center">
										<i className="la la-hourglass-half text-white font-large-2 float-left"></i>
									</div>
									<div className="media-body text-white text-right">
										<h3 className="text-white">{cantidad('PENDIENTE')}</h3>
										<span><FormattedMessage id="solicitudesCards.pendientes" defaultMessage="Pendientes" /></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-12" style={{ cursor: 'pointer' }} onClick={() => onFilter('LIBERADA')}>
					<div className="card" style={{ backgroundColor: '#28D094' }}>
						<div className="card-content">
							<div className="card-body">
								<div className="media d-flex">
									<div className="align-self-center">
										<i className="ft-check-circle text-white font-large-2 float-left"></i>
									</div>
									<div className="media-body text-white text-right">
										<h3 className="text-white">{cantidad('LIBERADA')}</h3>
										<span><FormattedMessage id="solicitudesCards.liberadas" defaultMessage="Liberadas" /></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xl-4 col-lg-4 col-12" style={{ cursor: 'pointer' }} onClick={() => onFilter('RECHAZADA')}>
					<div className="card" style={{ backgroundColor: '#FF4961' }}>
						<div className="card-content">
							<div className="card-body">
								<div className="media d-flex">
									<div className="align-self-center">
										<i className="ft-x-circle text-white font-large-2 float-left"></i>
									</div>
									<div className="media-body text-white text-right">
										<h3 className="text-white">{cantidad('RECHAZADA')}</h3>
										<span><FormattedMessage id="solicitudesCards.rechazadas" defaultMessage="Rechazadas" /></span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default SolicitudesCards;
